import React  from 'react'


class MessageDiv extends React.Component 
{
    static defaultProps=
    {
        className:"text-center p-1",
        message:"Default message"
    }
    
    render()
    {
        return (
            <div className={this.props.className}>
                {this.props.message}
            </div>
        );
    }
}


export default MessageDiv;
